import React from 'react'
import {
  AgxColumn,
  AgxRow,
  AgxTypography,
  AgxDivider,
  AgxToggleSwitch,
} from '@urbanx/agx.ui-components2'
import AppointmentPeriod from './AppointmentPeriod'
import { TaskStepDto } from '@urbanx/agx.activities.client'
import { ListingAgreementDetails } from '@urbanx/agx.campaigns.client'

const toDate = (iso?: string | null) => (iso ? new Date(iso) : undefined)
const toIso = (d?: Date) => (d ? d.toISOString() : undefined)

export const NSWAgreementTypeStageSteps = ({
  agreementDetails,
  onAgreementDetailsUpdated,
  tasksStage,
  updateTaskStep,
}: {
  agreementDetails?: ListingAgreementDetails
  onAgreementDetailsUpdated: (updated: { id: string; value: ListingAgreementDetails }) => void
  isOpen: boolean
  exceededGap: boolean
  tasksStage: TaskStepDto[]
  updateTaskStep: (step: TaskStepDto, isChecked: boolean) => void
}) => {
  const showHeader = (index: number) => [0, 1, 4].includes(index)
  const showDivider = (index: number) => [0, 3, 5].includes(index)
  const showOptions = (index: number) => [0, 1, 2, 3, 4, 5].includes(index)

  const headerLabels: Record<number, string> = {
    0: 'Part 1 - Agent',
    1: 'Part 2 - Price',
    4: 'Part 3 - Signature and Date',
    6: 'Page 3 - Appointment period',
  }

  return (
    <AgxColumn gap="spacing-2xl" fill padding={{ bottom: 'spacing-8xl' }}>
      {tasksStage.map((task, index) => {
        const header = headerLabels[index]
        const key = task.order ?? index

        return (
          <React.Fragment key={key}>
            {showHeader(index) && (
              <AgxTypography size="medium" type="title" id={`modalTitle-${index}`}>
                {header}
              </AgxTypography>
            )}

            {showOptions(index) && (
              <AgxRow
                gap="spacing-lg"
                justifyContent="space-between"
                alignItems="flex-start"
                fill
              >
                <AgxRow justifyContent="left" alignItems="flex-start">
                  <AgxTypography
                    id={`lbl-${task.order ?? index}`}
                    type="body_ui"
                    size="small"
                  >
                    {task.name}
                  </AgxTypography>
                </AgxRow>

                <AgxRow justifyContent="right" alignItems="flex-start">
                  <AgxToggleSwitch
                    id={`step-${task.order ?? index}`}
                    checked={task.isCompleted ?? false}
                    onChange={(isChecked: boolean) => updateTaskStep(task, isChecked)}
                  />
                </AgxRow>
              </AgxRow>
            )}

            {showDivider(index) && <AgxDivider variant="horizontal" />}
          </React.Fragment>
        )
      })}

      {agreementDetails && (
        <>
          <AgxTypography size="medium" type="title" id="modalTitle-appointment-period">
            Page 3 - Appointment period
          </AgxTypography>

          <AppointmentPeriod
            value={{
              startDate: toDate(agreementDetails.startDate as any),
              endDate: toDate(agreementDetails.endDate as any),
            }}
            onChange={(updated) => {
              onAgreementDetailsUpdated({
                id: 'period',
                value: {
                  ...agreementDetails,
                  startDate: updated.startDate ? toIso(updated.startDate) : agreementDetails.startDate,
                  endDate: updated.endDate ? toIso(updated.endDate) : agreementDetails.endDate,
                } as ListingAgreementDetails,
              })
            }}
          />
        </>
      )}
    </AgxColumn>
  )
}

export default NSWAgreementTypeStageSteps
